import { bootstrapApplication } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import themes from 'devextreme/ui/themes';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { licenseKey } from './devextreme-license';

config({ licenseKey });

themes.initialized(() => bootstrapApplication(App, appConfig).catch((err) => console.error(err)));
